import axios from "axios";
import Nprogress from 'nprogress'
import { Message } from "element-ui";
// import router from '@/router'
const BASEURL = `/api`;



const service = axios.create({
    baseURL: BASEURL,
});
service.interceptors.request.use(
    config => {
        Nprogress.start();
        if (localStorage.getItem('token')) {
            config.headers.Authorization = localStorage.getItem('token')
        }
        return config
    },
    error => {
        return Promise.reject(error,4)
    }
)

service.interceptors.response.use(
    config => {
        Nprogress.done()
        console.log(config)
        return config.data
    },
    error => {
        console.dir(error,5);
        Message({
            type: "error",
            message: error.response.data.status + error.response.data.error,
        });
        return Promise.reject(error);
    }
)

export default service;